import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Enhanced version of cn that adds a webflow isolation prefix
 * This ensures Tailwind classes work within Webflow without conflicts
 */
export function webflowCn(...inputs: ClassValue[]) {
  // Add the webflow isolation class to all class combinations
  return `wf-isolated ${twMerge(clsx(inputs))}`
}

/**
 * Format a date for display without timezone adjustments
 * @param date Date object or undefined
 * @returns Formatted date string or 'N/A' if date is undefined
 */
export function formatDate(date: Date | undefined) {
  if (!date) return 'N/A';
  
  // Use timeZone: 'UTC' to ensure dates are displayed without timezone adjustments
  // This ensures that if a date is stored as the 20th in the database,
  // it will display as the 20th regardless of the user's timezone
  const options: Intl.DateTimeFormatOptions = { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric',
    timeZone: 'UTC'
  };
  
  return date.toLocaleDateString('en-US', options);
}
